import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { AdminProvider } from './contexts/AdminContext'
import { NotificationProvider } from './contexts/NotificationContext'
import ErrorBoundary from './components/common/ErrorBoundary'
import LoginForm from './components/auth/LoginForm'
import AdminLogin from './components/auth/AdminLogin'
import DashboardLayout from './components/dashboard/DashboardLayout'
import DashboardHome from './components/dashboard/DashboardHome'
import EventsList from './components/dashboard/EventsList'
import Weather from './components/dashboard/Weather'
import Maps from './components/dashboard/Maps'
import DriverDashboard from './pages/DriverDashboard'
import ProfilePage from './pages/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import AdminLayout from './components/admin/AdminLayout'
import AdminDashboard from './components/admin/AdminDashboard'
import DriverManagement from './components/admin/DriverManagement'
import EventManagement from './components/admin/EventManagement'
import './App.css'
import { useEffect } from 'react'
import { initRealtime } from './services/realtime'

function App() {
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      initRealtime(token);
    }
  }, []);
  return (
    <ErrorBoundary>
      <NotificationProvider>
        <AdminProvider>
          <AuthProvider>
            <Router>
              <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<LoginForm />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              
              {/* Protected Dashboard Routes (Driver) */}
              <Route path="/dashboard" element={
                <DashboardLayout>
                  <DashboardHome />
                </DashboardLayout>
              } />
              
              <Route path="/events" element={
                <DashboardLayout>
                  <EventsList />
                </DashboardLayout>
              } />
              
              <Route path="/map" element={
                <DashboardLayout>
                  <Maps />
                </DashboardLayout>
              } />
              
              <Route path="/weather" element={
                <DashboardLayout>
                  <Weather />
                </DashboardLayout>
              } />
              
              <Route path="/profile" element={
                <DashboardLayout>
                  <ProfilePage />
                </DashboardLayout>
              } />
              
              <Route path="/settings" element={
                <DashboardLayout>
                  <SettingsPage />
                </DashboardLayout>
              } />
              
              <Route path="/drivers" element={
                <DashboardLayout>
                  <DriverDashboard />
                </DashboardLayout>
              } />

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="drivers" element={<DriverManagement />} />
                <Route path="events" element={<EventManagement />} />
                <Route path="settings" element={<div>Settings (Coming Soon)</div>} />
              </Route>
              
              {/* Redirect routes */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* 404 handler */}
            <Route path="*" element={
              <div className="not-found">
                <h1>404 - Seite nicht gefunden</h1>
                <p>Die angeforderte Seite existiert nicht.</p>
                <a href="/dashboard">Zurück zum Dashboard</a>
              </div>
            } />
            </Routes>
          </div>  
        </Router>
      </AuthProvider>
    </AdminProvider>
    </NotificationProvider>
    </ErrorBoundary>
  )
}export default App
